module.exports = __webpack_public_path__ + "static/media/404.d6193b4c.png";